<template>
  <div class="pageDesignerRight-table-main">
<!--    <div class="right-title">-->
<!--      <div class="title-left">组件设置 - 普通表格</div>-->
<!--      <div class="title-right">-->
<!--        <el-button type="primary" @click="refreshTableStyle">刷新表格样式</el-button>-->
<!--      </div>-->
<!--    </div>-->
    <div class="right-content">
      <el-form size="small" label-width="90px" label-suffix="：">
        <el-form-item  label="数据源">
          <xr-page-select :selectName="activeData.interfaceCategoryName" @cleanPageSelect="cleanCategory()" @pageSelect="categorySelect()">
            <el-input slot="page-select-name" v-model="activeData.interfaceCategoryName"></el-input>
            <input slot="page-select-id" v-model="activeData.interfaceCategoryId" type="hidden"></input>
          </xr-page-select>
        </el-form-item>
        <el-form-item  label="数据key">
          <el-input v-model="activeData.dataServerKey" placeholder="列表serviceKey" />
        </el-form-item>
        <el-form-item  label="主键字段">
          <el-input v-model="activeData.primaryKey" placeholder="主键字段" />
        </el-form-item>
        <el-form-item  label="条件区显示">
          <el-select v-model="activeData.isShowSearch" style="width: 100%">
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="表格高度">
          <el-input v-model="activeData.tableHeight" placeholder="可以不设置" />
        </el-form-item>
        <el-form-item  label="数据列">
          <el-button type="primary" @click="columnSetting">数据列配置</el-button>
        </el-form-item>
        <el-form-item  label="工具栏">
          <el-button type="primary" @click="toolbarSetting">工具栏配置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 委托单位选择 -->
    <page-select-dialog ref="pageSelectDialog" :type="pageDialogType"  @confirmMethod="pageSelectCallback(arguments)"></page-select-dialog>

    <!-- 表格列配置 -->
    <el-dialog title="表格列配置" :visible.sync="columnDialogVisible"  :close-on-click-modal="false" :modal-append-to-body="true"  width="1800px">
      <div class="main-box pageDesignerRight-table-column"  style="height: 600px;padding: 10px">
        <el-form ref="dataForm" id="dataForm" :model="activeData" label-width="70px" label-suffix="：">
          <el-row :gutter="15" v-for="(item,index) in activeData.columnList" :key="index">
            <el-col :span="3">
              <el-form-item  label="控件类型">
                <el-select v-model="item.columnType" style="width: 100%">
                  <el-option label="文本" value="input"></el-option>
                  <el-option label="数字" value="number"></el-option>
                  <el-option label="序号" value="sn"></el-option>
                  <el-option label="列多选框" value="ck"></el-option>
                  <el-option label="列单选框" value="radio"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item  label="列编码">
                <el-input v-model="item.columnField" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="3" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item  label="列名称">
                <el-input v-model="item.columnTitle" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <el-form-item  label="是否居中">
                <el-select v-model="item.isCenter" style="width: 100%">
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item  label="列宽度" prop="columnWidth">
                <el-input v-model="item.columnWidth" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <el-form-item  label="排序号">
                <el-input v-model="item.orderNum" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="item.columnType != 'sn' && item.columnType != 'ck' && item.columnType != 'radio'">
              <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delColumn(index)"></i>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-button type="primary" @click="addColumn">增加一列</el-button>
              <el-button type="primary" @click="addColumnFormDataSource">数据源拉取</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="default" @click="columnDialogVisible = false">关闭</xr-button>
      </div>
    </el-dialog>

    <!-- 工具栏配置 -->
    <el-dialog title="工具栏配置" :visible.sync="toolbarDialogVisible" :close-on-click-modal="false" :modal-append-to-body="true" width="1800px">
      <div class="main-box pageDesignerRight-table-column"  style="height: 600px;padding: 10px">
        <el-form ref="dataForm" id="dataForm" :model="activeData" label-width="70px" label-suffix="：">
          <el-row :gutter="15" v-for="(item,index) in activeData.toolbarList" :key="index">
            <el-col :span="3">
              <el-form-item  label="类型">
                <el-select v-model="item.toolbarType" style="width: 100%" @change="toolbarTypeChange($event,index)">
                  <el-option label="新增" value="save"></el-option>
                  <el-option label="修改" value="edit"></el-option>
                  <el-option label="删除" value="delete"></el-option>
                  <el-option label="通用" value="common"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item  label="名称">
                <el-input v-model="item.toolbarText" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item  label="图标">
                <el-input v-model="item.toolbarIconCls" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="item.toolbarType == 'save' || item.toolbarType === 'edit'">
              <el-form-item  label-width="90px" label="关联页面">
                <xr-page-select :selectName="item.relatePageName" @cleanPageSelect="cleanPageSelect(index)" @pageSelect="pageSelect(index)">
                  <el-input slot="page-select-name" v-model="item.relatePageName"></el-input>
                  <input slot="page-select-id" v-model="item.relatePageId" type="hidden"></input>
                </xr-page-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="item.toolbarType == 'delete'">
              <el-form-item  label-width="90px" label="删除key">
                <el-input v-model="item.dataServerKey1" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item  label="顺序号">
                <el-input v-model="item.orderNum" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <i style="color: #518de6;cursor: pointer;font-size: 20px;margin-top: 5px;margin-left: 10px" class="el-icon-remove-outline" @click="delToolbar(index)"></i>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-button type="primary" @click="addToolbar">增加一列</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
<!--        <xr-button type="primary" @click="save('dataForm')">确定</xr-button>-->
        <xr-button type="default" @click="toolbarDialogVisible = false">取消</xr-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "normalTable",
  props: ['activeData', 'pageId', 'pageTemp'],
  data(){
    return {
      columnDialogVisible: false,                //配置列的是否显示
      toolbarDialogVisible: false,               //工具栏配置的是否显示
      toolbarSelectedIndex: 0,                   //工具栏选择的序号
      pageDialogType: 'interfaceCategory'        //弹出框类型
    }
  },
  created() {

  },
  methods:{
    //增加一列
    addToolbar(){
      let obj = new Object();
      obj['columnType'] = 'txt';
      obj['isCenter'] = '0';
      this.activeData.toolbarList.push(obj);
    },
    //删除一行
    delToolbar(index){
      this.activeData.toolbarList.splice(index,1)
    },
    //增加一行
    addColumn(){
      let obj = new Object();
      obj['columnType'] = 'txt';
      obj['isCenter'] = '0';
      this.activeData.columnList.push(obj);
    },
    //从数据源拉取
    addColumnFormDataSource(){
      //如果没有选择数据源，提示用户。
      if(!this.activeData.interfaceCategoryId){
        this.$message.warning('未设置数据源，不能拉取！');
        return false;
      }
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method':'tGenerateTableColumn_listByCategoryId',
          'categoryId': this.activeData.interfaceCategoryId
        }
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }
        //获取列表
        if(response.rows && response.rows.length > 0){
          let rows = response.rows;
          for (let i = 0; i < rows.length; i++) {
            let info = rows[i];
            let javaField = '';
            let columnComment = '';
            if(!!info.javaField){
              javaField = info.javaField;
            }
            if(!!info.columnComment){
              columnComment = info.columnComment;
            }
            let obj = new Object();
            obj['columnField'] = javaField;
            obj['columnTitle'] = columnComment;
            obj['columnType'] = 'txt';
            obj['isCenter'] = '0';
            this.activeData.columnList.push(obj);
          }
        }

      })


      let obj = new Object();
      obj['columnType'] = 'txt';
      obj['isCenter'] = '0';
      this.activeData.columnList.push(obj);
    },
    //删除一行
    delColumn(index){
      this.activeData.columnList.splice(index,1)
    },
    cleanCategory(){
      this.activeData.interfaceCategoryId = '';
      this.activeData.interfaceCategoryName = '';
    },
    categorySelect(){
      this.pageDialogType = 'interfaceCategory'
      this.$nextTick(()=>{
        this.$refs.pageSelectDialog.init() //初始化页面
      })
    },
    cleanPageSelect(index){
      this.toolbarSelectedIndex = index;
      this.activeData.toolbarList[index].relatePageId = '';
      this.activeData.toolbarList[index].relatePageName = '';
    },
    pageSelect(index){
      this.toolbarSelectedIndex = index;
      this.pageDialogType = 'generatePageSelect'
      this.$nextTick(()=>{
        this.$refs.pageSelectDialog.init('', this.pageId) //初始化页面
      })
    },
    //pageSelect确定
    pageSelectCallback(msg){
      let result = msg[0];
      if(this.pageDialogType == 'interfaceCategory'){
        this.activeData.interfaceCategoryId = result.id
        this.activeData.interfaceCategoryName = result.categoryName
        let categoryCode = result.categoryCode;
        this.activeData.dataServerKey = categoryCode + '_list';
      }else if(this.pageDialogType == 'generatePageSelect'){
        let index = this.toolbarSelectedIndex
        this.activeData.toolbarList[index].relatePageId = result.id
        this.activeData.toolbarList[index].relatePageName = result.pageName
      }


    },
    //打开【表格列】配置
    columnSetting(){
      this.columnDialogVisible = true;
    },
    //打开【工具栏】配置
    toolbarSetting(){
      this.toolbarDialogVisible = true;
    },
    //刷新表格样式
    refreshTableStyle(){
      //重置 configure 数据
      let columnList = this.activeData.columnList;
      let columns = [];
      for(let i = 0; i < columnList.length; i ++){
        let columnItem = columnList[i];
        let columnType = columnItem.columnType;
        let isCenter = columnItem.isCenter;
        let columnField = columnItem.columnField;
        let columnTitle = columnItem.columnTitle;
        let columnWidth = columnItem.columnWidth;  //列宽度
        let obj = new Object();
        if(columnType === 'sn'){  //如果是序号
          obj['field'] = 'sn';
        }else if(columnType === 'ck'){  //如果是多选框
          obj['field'] = 'ck';
        }else if(columnType === 'radio'){  //如果是单选框
          obj['field'] = 'radio';
        }else{
          obj['field'] = columnField;
          obj['title'] = columnTitle;
        }
        if(isCenter === '1'){  //如果设置了居中，则设置居中
          obj['align'] = 'center';
        }
        if(!!columnWidth){  //如果设置了居中，则设置居中
          obj['width'] = columnWidth;
        }
        columns.push(obj);
      }

      let isShowSearch = false;
      if(this.activeData.isShowSearch === '1'){
        isShowSearch = true;
      }
      this.activeData.configure['url'] = '/web/service?method=' + this.activeData.dataServerKey;
      this.activeData.configure['columns'] = columns;
      this.activeData.configure['isShowSearch'] = isShowSearch;
      this.activeData.configure['toolbar'] = this.activeData.toolbarList;
      this.$emit('refreshTableStyle')
    },
    //工具栏类型修改事件
    toolbarTypeChange(newVal, index){
      if(newVal == 'save'){
        this.activeData.toolbarList[index]['toolbarText'] = '新增';
        this.activeData.toolbarList[index]['toolbarIconCls'] = 'wk wk-add';
      }else if(newVal == 'edit'){
        this.activeData.toolbarList[index]['toolbarText'] = '修改';
        this.activeData.toolbarList[index]['toolbarIconCls'] = 'wk wk-edit';
      }else if(newVal == 'delete'){
        this.activeData.toolbarList[index]['toolbarText'] = '删除';
        this.activeData.toolbarList[index]['toolbarIconCls'] = 'wk wk-discard';
        if(!!this.pageTemp.categoryKeyCode){
          this.activeData.toolbarList[index]['dataServerKey1'] = this.pageTemp.categoryKeyCode + "_deleteBatch";
        }
      }
    }
  }
}
</script>

<style scoped>
  .pageDesignerRight-table-column .el-form-item__label{padding: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/components/PageDesigner/item/normalTable.vue